"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var login_service_1 = require("../../../_service/login.service");
var core_tenant_service_1 = require("../../../_service/core-tenant.service");
var OrganisationFilterComponent = /** @class */ (function () {
    function OrganisationFilterComponent(loginService, tenantService) {
        this.loginService = loginService;
        this.tenantService = tenantService;
        this.selectedTenants = [];
        this.tenantSelectionChanged = new core_1.EventEmitter();
    }
    OrganisationFilterComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.loginService.getLoggedIn().toPromise()];
                    case 1:
                        _a.volunteer = (_c.sent());
                        _b = this;
                        return [4 /*yield*/, this.tenantService.findByUserId(this.volunteer.id).toPromise()];
                    case 2:
                        _b.tenants = (_c.sent());
                        this.selectedTenants = __spread(this.tenants);
                        this.tenantSelectionChanged.emit(this.selectedTenants);
                        return [2 /*return*/];
                }
            });
        });
    };
    OrganisationFilterComponent.prototype.tenantClicked = function (tenant) {
        var t = this.selectedTenants.find(function (t) { return t.id === tenant.id; });
        var index = this.selectedTenants.findIndex(function (t) { return t.id === tenant.id; });
        if (index >= 0) {
            this.selectedTenants.splice(index, 1);
        }
        else {
            this.selectedTenants.push(tenant);
        }
        this.tenantSelectionChanged.emit(this.selectedTenants);
    };
    OrganisationFilterComponent.prototype.tenantSelected = function (tenant) {
        return this.selectedTenants.findIndex(function (t) { return t.id === tenant.id; }) >= 0;
    };
    return OrganisationFilterComponent;
}());
exports.OrganisationFilterComponent = OrganisationFilterComponent;
